import { apiInstances } from '../../../libs';

const { get } = apiInstances.userInstance;

export default function getPaymentPeriods({ service }) {
  return get(`/clouders/payment-periods?service=${service}`);
}
